import React from "react";
import Button from "component/button/Button";

import html2pdf from "html2pdf.js/dist/html2pdf.min.js";

import { colors, strings } from "asset/constant";
import { useFlag } from "hook";

const ExportPDF: React.FC<ExportPDF> = ({ template, button, extraData }) => {
  const { flg: loading, on: startLoading, off: stopLoading } = useFlag();

  const _onExportPdf = () => {
    startLoading();
    html2pdf()
      .set({
        margin: 12,
        filename: `${strings.factor} ${extraData?.company_name} (${
          strings.number
        } ${extraData?.id}) - ${Date.now().toString().substring(5)}.pdf`,

        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: "portrait" },
      })
      .from(template)
      .save()
      .then(stopLoading);
  };

  return (
    <>
      <Button
        loading={loading}
        onPress={_onExportPdf}
        bgColor={colors.theme}
        absolute={{ bottom: 10, left: 10 }}
        width={100}
        style={{ paddingHorizontal: 20 }}
        icon={{ name: "export" }}
        title={{ value: "خروجی" }}
      />
    </>
  );
};

export default ExportPDF;
